import { render, staticRenderFns } from "./edit-long-booking.vue?vue&type=template&id=893c28dc&"
import script from "./edit-long-booking.vue?vue&type=script&lang=js&"
export * from "./edit-long-booking.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports